// extracted by mini-css-extract-plugin
export var deleteModal = "_fc-0";